import api from "./client";

export interface ShipStationServiceOption {
  serviceCode: string;
  name: string;
  domestic?: boolean;
  international?: boolean;
}

export interface ShipStationCarrierOption {
  carrierId: string;
  carrierCode: string;
  name: string;
  services: ShipStationServiceOption[];
}

export interface SandboxCarrier {
  code: string;
  name: string;
}

export const carriers = {
  getSettings: () => api.get("/carriers/settings").then((res) => res.data),
  /** Enabled carriers in Sandbox Mode (test labels), for the ship screens' warning. */
  getSandboxCarriers: (): Promise<SandboxCarrier[]> =>
    api.get("/carriers/sandbox").then((res) => res.data),
  toggle: (data: { carrierId: string; isActive: boolean }) =>
    api.post("/carriers/toggle", data).then((res) => res.data),
  /** Carrier Settings → Magento access: whether API callers (the store's checkout) may use it. */
  setApiAccess: (data: { carrierId: string; apiAccess: boolean }) =>
    api.post("/carriers/api-access", data).then((res) => res.data),
  saveCredentials: (data: { carrierId: string; credentials: any }) =>
    api.post("/carriers/credentials", data).then((res) => res.data),

  // --- ShipStation (rating only) ---
  // `apiKey` is optional once any ShipStation carrier has a key saved: the API
  // falls back to the stored one.
  listShipStationCarriers: (
    apiKey?: string,
    apiSecret?: string,
    apiVersion?: string,
    // Asks the account again rather than reading the six-hour server cache,
    // for when a carrier was just connected in ShipStation.
    refresh?: boolean,
  ): Promise<ShipStationCarrierOption[]> =>
    api
      .get("/carriers/shipstation/carriers", {
        params: { apiKey, apiSecret, apiVersion, ...(refresh ? { refresh: 1 } : {}) },
      })
      .then((res) => res.data),
  listShipStationServices: (
    carrierIdOrCode: string,
    apiKey?: string,
    apiSecret?: string,
    apiVersion?: string,
  ): Promise<ShipStationServiceOption[]> =>
    api
      .get(`/carriers/shipstation/services/${carrierIdOrCode}`, {
        params: { apiKey, apiSecret, apiVersion },
      })
      .then((res) => res.data),
  syncShipStationCarriers: (
    apiKey: string,
    apiSecret?: string,
    apiVersion?: string,
  ) =>
    api
      .post("/carriers/shipstation/sync", { apiKey, apiSecret, apiVersion })
      .then((res) => res.data),
};
